import styles from "./fileaction.module.css";

export const Button = ({ cssStyle, clickHandler, btnName,style={},tabIndex=0 }) => {
  return (
    <button className={styles[cssStyle]} onClick={clickHandler} style={style} tabIndex={tabIndex}>
      {btnName}
    </button>
  );
};
